'use client'

import { Container } from '@mui/material'

import Header from '@/components/common/header'
import Footer from '@/components/common/footer'

import type { ContentLayoutProps } from '@/types/components'

const ContentLayout = ({ children, className, pageWidth = 'normal', pageContext, ...rest }: ContentLayoutProps) => {
  return (
    <>
      <Header data={rest.menuData} navIcons={rest.navIcons} />
      <Container
        id='main-content'
        component='main'
        maxWidth={false}
        tabIndex={-1}
        sx={{
          px: '0 !important',
          flex: 1,
          display: 'block',
          pt: (theme) => ({
            xs: `${theme.mixins.toolbar.minHeight}px`,
            sm: `calc(${theme.mixins.toolbar.minHeight}px + ${theme.spacing(1)})`,
            lg: `calc(${theme.mixins.toolbar.minHeight}px + ${theme.spacing(2)})`
          })
        }}>
        {children}
      </Container>
      <Footer menuData={rest.menuData} />
    </>
  )
}

export default ContentLayout
